import { ScheduleService } from '@/tools/services/schedule.service';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
    EdClassSchedule: () => import(/* EdClassSchedule */'@/tools/components/class-builder/ed-class-schedule/ed-class-schedule.component.vue')
  }
})
export default class EdClassScheduleView extends Vue {
  schedule: any = null;

  created() {
    const classId = Number(this.$route.params.classId);

    this.getScheduleByClassId(classId);
  }

  async getScheduleByClassId(classId: number) {
    const schedule = await ScheduleService.getScheduleByClassId(classId);
    
    this.schedule = schedule;
  }

  returnToAdmin() {
    this.$router.push({ name: 'class-admin' });
  }
}